import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchUsers, userUndeletable } from '../../actions';
import { removeUser } from '../../actions';

class UserList extends Component {

	constructor (props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
		this.handleUserLoeschen = this.handleUserLoeschen.bind(this);
		this.state = {
			selectedRows: [],
			hinweis: "",
			modalText: "Sie haben keine Email zum Verschicken ausgewählt."
		}
	}

	componentDidMount() {
		console.log("mounting UserList");
		this.props.fetchUsers();
	}

	testSelected(id) {
		return this.state.selectedRows.includes(id);
	}

  handleClick(e) {
		console.log(e);
	}

	handleChange(e) {
		console.log("change");
	}


	toggleRow(id) {
		const isIncluded = this.state.selectedRows.includes(id);
		const isOwnId = this.props.auth._id === id;

		console.log("auth in toggleRow:", this.props.auth._id);
		console.log("isOwnId:", isOwnId);

		if (!isIncluded) {
			if (!isOwnId) {
				this.setState({ selectedRows: [...this.state.selectedRows, id]});
			} else {
				;
				//this.props.userUndeletable();
			}
		} else {
			var array = [...this.state.selectedRows];
			const index = array.indexOf(id);
			array.splice(index, 1);
			this.setState({selectedRows: array});
		}
		console.log(this.state.selectedRows);
	}

	handleUserLoeschen(e) {
		e.preventDefault();

		const userListLength = this.state.selectedRows.length;

		console.log("userListLength:", userListLength);
		console.log("auth:", this.props.auth);

		if (userListLength > 0) {
			console.log("User löschen");
			this.props.removeUser(this.state.selectedRows);
		} else {
			this.setState.modalText = "Sie haben keine User zum Löschen ausgewählt.";
			this.openModal();
		}
	}

	localDateString(einDatum) {
		const d = new Date(einDatum);
		//console.log(d);

		return (
			<React.Fragment>
				<span>{`${d.getDate()}.${d.getMonth()+1}.${d.getFullYear()}`}</span>
				<span> <i className="material-icons left" style={{verticalAlign: 'middle'}}>done</i></span>
			</React.Fragment>
		)
	}

	renderUsers() {
		return this.props.users.map((u,i) => {
			if (this.props.auth) {
				//console.log("about to render user entry");
				//console.log("my auth:", this.props.auth);
				//console.log("user:", u);

			const aboutMe = this.props.auth._id === u._id;
			const myUserLink = "/prefs";
			const theirUserLink = "/user/prefs/" + u.username;
			const userLink =  aboutMe ? myUserLink : theirUserLink;
			const linkText = aboutMe ? 'eigene Einstellungen' : 'Einstellungen';

			return (
				<tr key={u._id} id={u._id} style={{ backgroundColor: this.testSelected(u._id) ? '#efe':'#fff'}} onClick={(e) => this.toggleRow(u._id)}>
					<td>{i+1}</td>
					<td>{u.username}</td>
					<td>{u.roles.toString()}</td>
					<td><Link to={userLink}>{linkText}</Link></td>
				</tr>
			)} else {
				return ''
			}
		})
	}

	render() {

		if (this.props.hinweis) {
			console.log("hinweis:", this.props.hinweis.message);
		}
		return (
			<div>
				<h4 style={{fontStyle:'italic'}}>Benutzer (Fuhrpark-Verantwortliche)</h4>
				 <table className="table w-100">
					<thead style={{backgroundColor: '#e6e6e6'}}>
						<tr>
								<th>Nummer</th>
								<th>Email/Username</th>
								<th>Rollen</th>
								<th>Einstellungen</th>
						</tr>
					</thead>
					<tbody>
						{this.renderUsers()}
					</tbody>
				</table>
				<div>
					<button
						className="float-right btn btn-default"
						disabled={this.state.selectedRows.length < 1}
						onClick={this.handleUserLoeschen}>
							Löschen
					</button>
				</div>
				<Link to="/user/register">
					<button type="button" className="float-right btn btn-default" style={{marginRight: '8px'}}>
						<span style={{color: 'white'}}>User neu</span>
					</button>
				</Link>
				<div style={{height:'150px'}}></div>
			</div>
		);
	}
}

// Löschen-Knopf, bisherige Bedingung: disabled={this.state.selectedRows.length < 1}

const mapDispatchToProps = {
	fetchUsers, removeUser, userUndeletable
}

function mapStateToProps({ users, auth, hinweis }) {
	return { users, auth, hinweis }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(UserList);



// WEBPACK FOOTER //
// ./src/components/user/UserList.js